<script setup lang="ts"></script>

<template>
  <div
    role="list"
    class="flex flex-wrap flex-col gap-y-2 md:gap-x-[30px] text-emphasis sm:flex-row mb-3"
  >
    <slot></slot>
  </div>
</template>
